import React from 'react';
import styled, { css } from 'styled-components';
import { BLUE_GREY } from '../../../theme';

const Container = styled.div`
  font-size: 12px;
  line-height: 1.17;
  letter-spacing: -0.1px;
  color: ${BLUE_GREY};
`;

const Italic = styled.i`
  font-style: italic;
`;

const Link = styled.a`
  ${(props) => props.isAvisSolution && css`color: #313b82 !important;`}
`;

type FootnoteProps = {
  isAvisSolution?: boolean;
};

const Footnote = ({ isAvisSolution }: FootnoteProps) => {
  const mailto = isAvisSolution ? 'contact@avis-solutions.fr' : 'contact@vroomvroom.fr';

  return (
    <Container>
      {isAvisSolution ? `
        Les données de ce formulaire sont utilisées pour la publication de l'avis et par Avis Solution pour le respect de
        ses obligations légales. Elles sont conservées pendant la durée de publication.
      ` : `
        Les données de ce formulaire font l’objet de traitements dont le responsable est Vroom France - 13 rue Olier 75015 Paris.
        Elles sont utilisées pour la collecte, la modération et la diffusion des avis et le respect par Vroom France de ses obligations légales.
        Elles sont conservées pour une durée maximale de dix (10) ans.
      `}
      Vous disposez d’un droit d’accès, de rectification, de limitation, de portabilité,
      d’opposition, de suppression et vous pouvez définir des directives
      <Italic> post mortem </Italic>
      relatives à vos données. Vous pouvez exercer vos droits en envoyant un email à
      {' '}
      <Link isAvisSolution href={`mailto:${mailto}`}>{mailto}</Link>
      {' '}
      ou en contactant le Délégué à la protection des données de
      {' '}
      {isAvisSolution ? 'Enpc' : 'Vroom France'}
      . Pour en savoir plus, vous pouvez consulter notre
      {' '}
      <Link
        href={isAvisSolution ? 'https://www.prepacode-enpc.fr/politique-de-confidentialite' : '/a-propos/donnees-personnelles'}
        isAvisSolution
        target="_blank"
        rel="noopener noreferrer"
      >
        politique de protection des données.
      </Link>
    </Container>
  );
};

Footnote.defaultProps = {
  isAvisSolution: false,
};

export { Footnote };
